const MonthControl = ({ activeMonth, previousMonth, nextMonth, t }) => (
  <div className="schedule-calendar-toolbar">
    <div>
      <span className="dashboard-section__eyebrow">My calendar</span>
      <h2>{t("Schedule")}</h2>
      <p>Select a scheduled date to view attendance and shift details.</p>
    </div>

    <div className="schedule-calendar-toolbar__navigation" aria-label="Calendar month navigation">
      <button type="button" onClick={previousMonth} aria-label="Previous month">
        <i className="fas fa-chevron-left" aria-hidden="true" />
      </button>
      <strong aria-live="polite">{activeMonth.startDate.format("MMMM YYYY")}</strong>
      <button type="button" onClick={nextMonth} aria-label="Next month">
        <i className="fas fa-chevron-right" aria-hidden="true" />
      </button>
    </div>
  </div>
);

export default MonthControl;
